<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Dashboard</span>
        <h3 class="page-title">{{church_name}}</h3>
      </d-col>
    </d-row>

    <!-- Small Stats Blocks -->
    <d-row>
      <d-col lg v-for="(stats, idx) in smallStats" :key="idx" class="mb-4" md=6 lg=4 sm=12>
        <small-stats :id="`small-stats-${idx}`" variation="1" :chart-data="stats.datasets" :label="stats.label" :value="stats.value" :percentage="stats.percentage" :increase="stats.increase" :decrease="stats.decrease" />
      </d-col>
    </d-row>

    <d-row v-if="cys.length>0">
      <!-- Users Overview -->
      <d-col lg="8" md="6" sm="12" class="mb-4">
        <bo-current-year-stats :chart-data="cys" label="Current Year Stats" id='cys1'
        :labels="cyslabels"
        variation="1" 
        />
      </d-col>
    </d-row>

  </d-container>
</template>

<script>
import SmallStats from '@/components/common/SmallStats.vue';
//import CurrentYearStats from '@/components/dashboard/CurrentYearStats.vue';

export default {
  components: {
    SmallStats,
//    boCurrentYearStats: CurrentYearStats,
  },
  data() {
    return {
      church_name:'',
      modules:[],
      dateRange: {
        from: null,
        to: null,
      },
      smallStats:[],
      cys:[],//current year stats
      cyslabels:[],
    };
  },
  watch:{
  },
  mounted(){
//    this.church_name=this.$store.state.church_name;
    this.modules=[ 
    { name: 'total_person/0', type: 'smallStats' },
    { name: 'total_person/1', type: 'smallStats' },
    { name: 'total_person/2', type: 'smallStats' },
    { name: 'total_person/3', type: 'smallStats' },
    { name: 'total_person/4', type: 'smallStats' },
//    { name: 'total_scan/22', type: 'smallStats' },
    ]
    this.init();
  },
  methods: {
    init(){
      let tmp = this.modules.shift();
      if (tmp)
      this.axios.get('/dashboard/'+tmp.name).then( resp=>{
        var data=JSON.parse(resp.data);
        data.datasets=[];
        data.value=new Intl.NumberFormat().format(data.value);
        this.smallStats.push(data);
        this.init()
      })
    }
  },
  computed: {
  },
};
</script>

